import { createRequire } from "node:module";

const require = createRequire(import.meta.url);
const pkg = require("../package.json") as { version: string };

/** Package version string. */
export const version = pkg.version;

export {
  ComponentSchema,
  OperationSchema,
  OptionSchema,
  JSONSchemaRefSchema,
  ArtifactSlotValueSchema,
  BindingRefSchema,
  SUPPORTED_SCHEMA_VERSIONS,
  SCHEMA_VERSION_PATTERN,
  type ComponentDSL,
  type OperationDSL,
  type OptionDSL,
  type JSONSchemaRefDSL,
  type BindingRefDSL,
} from "./schema.js";

export {
  parseComponentFile,
  parseComponentString,
  ComponentParseError,
} from "./parser.js";

export type {
  ComponentIR,
  OperationIR,
  OptionIR,
  JSONSchema,
  JSONSchemaRef,
  ProjectionTarget,
  ArtifactDirection,
  RiskLevel,
  BindingIR,
} from "./ir.js";

export {
  compileComponent,
  compileComponentAsync,
  compileComponentFile,
  extractFailureClasses,
  ComponentCompileError,
  type CompileComponentOptions,
} from "./compiler.js";

export {
  validateComponent,
  extractImplementationIds,
  ComponentValidationError,
  type ValidationOptions,
  type ImplementationIds,
} from "./validation.js";

export { resolveRefs, RefResolutionError } from "./ref-resolver.js";

export {
  generateAll,
  writeGeneratedFiles,
  typesGenerator,
  clientGenerator,
  runtimeGenerator,
  cliGenerator,
  handlerGenerator,
  bindingsGenerator,
  claudeGenerator,
  type GeneratedFile,
  type GenerateOptions,
  type Generator,
} from "./generators/index.js";

export {
  mergeCursorHooks,
  parseCursorHooksFile,
  serializeCursorHooksFile,
  type CursorHookEntry,
  type CursorHookCommand,
  type CursorHooksFile,
} from "./cli/governance.js";

export {
  DEFAULT_RECORDER_REL,
  isManagedRecorderPath,
  materializeRecorderScript,
  readRecorderScriptTemplate,
  unmaterializeRecorderScript,
} from "./cli/recorder-script.js";
